import { useMutation } from "react-query";
import downloadEStatement from "../services/downloadEStatement";

function useDownloadEStatement() {
  return useMutation(["download-e-statement"], downloadEStatement);
}

export default useDownloadEStatement;
